import { MobilePayments } from "@/pages/RegistrationPage/Components/MobilePayments";
import { appRouterPaths } from "@/services/navigation";
import type { RouteProps } from "react-router-dom";

export const mobilePaymentPageRoute: RouteProps = {
  path: appRouterPaths.mobilePayments,
  element: <MobilePayments />,
};
